import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {subscriptionManagement_template} from "../components/templates/subscriptionManagement_template";
import {vnApp_sentinelbi} from "../components/vnApp_sentinelbi";

declare var ko: any;
declare var page: any;

export class subscriptionManagement extends sentinelModule{

    protected XHRHdl: XMLHttpRequestHandler;
    protected subscriptionManagement_template: subscriptionManagement_template;

    protected getModuleName(){
        return "subscriptionManagement";
    }

    buildContent() : Array<Element>{

        const parentContent = super.buildContent();

        this.subscriptionManagement_template = new subscriptionManagement_template("subscriptionManagement", this.viewModel, this);
        return [...parentContent,this.subscriptionManagement_template.build()];
    }

    fillPage() : void{

        this.subscriptionManagement_template.initPlans();
        this.subscriptionManagement_template.initCardElement();
        this.getPermissions();
        this.getListFormData();
    }

    protected getPermissions(){

        this.loadingIn(this.subscriptionManagement_template.builtTemplate);

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.subscriptionManagement_template.setSideMenuPermissionsData(responseParsed);
                obj.getListFormData();
            })
        }
    }

    protected getListFormData(): void{

        let subViewModel = this.subscriptionManagement_template.getViewModelForRequest();

        let usrReq_url: string = '/api/settings/subscriptionManagement/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    obj.subscriptionManagement_template.getTemplateViewModel().currPlanId(responseParsed.planId)

                    if (responseParsed.planId == vnApp_sentinelbi.PLAN_BASIC_ID || responseParsed.planId == vnApp_sentinelbi.PLAN_ENTERPRISE_FREE_ID) {

                        //show payment form
                        obj.subscriptionManagement_template.getTemplateViewModel().showCheckout(true);
                    }else {

                        //show stripe link
                        obj.subscriptionManagement_template.getTemplateViewModel().sessionUrl(responseParsed.sessionUrl)
                        obj.subscriptionManagement_template.getTemplateViewModel().showManageSubscription(true);
                    }

                    // LOADING : ends
                    obj.loadingOut(obj.subscriptionManagement_template.builtTemplate);
                }
            }
        }
    }

    public applyPromo(){

        this.loadingIn(this.subscriptionManagement_template.builtTemplate);

        let subViewModel = this.subscriptionManagement_template.getViewModelForRequest();

        let usrReq_url: string = '/api/access/applyPromo/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onApplyPromoReturn;
        this.XHRHdl.execute();
    }

    protected onApplyPromoReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.subscriptionManagement_template.setPromoCodeData(responseParsed.promoCodeData);
            });

            if(req.request.readyState == 4){
                if (req.request.status == 200 || req.request.status == 400 || req.request.status == 500) {
                    // LOADING : ends
                    obj.loadingOut(obj.subscriptionManagement_template.builtTemplate);
                }
            }
        }
    }

    public checkout(){

        this.loadingIn(this.subscriptionManagement_template.builtTemplate);

        let subViewModel = this.subscriptionManagement_template.getViewModelForRequest();

        let usrReq_url: string = '/api/access/upgradePlan/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onCheckoutRequestReturn;
        this.XHRHdl.execute();
    }

    protected onCheckoutRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                //obj.subscriptionManagement_template.getTemplateViewModel().showCheckout(false);
                obj.subscriptionManagement_template.getTemplateViewModel().showPaymentConfirmation(true);
            });

            if(req.request.readyState == 4){

                if (req.request.status == 200 || req.request.status == 400 || req.request.status == 500) {

                    // LOADING : ends
                    obj.loadingOut(obj.subscriptionManagement_template.builtTemplate);
                }
            }
        }
    }

    protected onCloseConfirmationPopup() {

        page.redirect('/subscription_management/');
    }

    protected filterSingleGroupSelectorOnChange(id){

        if (id == 'plan') {

            this.subscriptionManagement_template.updatePlanId()
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/subscriptionManagement.ts